import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import styled from 'styled-components';

const GlobalLoadingSpinnerRoot = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgb(255 255 255 / 80%);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GlobalLoadingSpinner = () => {
  return (
    <GlobalLoadingSpinnerRoot>
      <Spinner size="huge" color="blue" />
    </GlobalLoadingSpinnerRoot>
  );
};
